/* eslint jsx-a11y/no-static-element-interactions:0 */

import React from 'react';
import cx from 'classnames';
import i18n from 'app/common/lib/i18n';
import PropTypes from 'prop-types';
import SocialConnectLib from 'app/common/lib/SocialConnect';
import SocialNetworkSettingsManager from 'app/common/lib/SocialNetworkSettings';
import { Touchable } from 'gestalt';

const { FACEBOOK, GPLUS, YAHOO } = SocialConnectLib;

function showSocialConnectPanel(network) {
  SocialNetworkSettingsManager.instance().handleConnect(network, true, {});
}

export default function SocialConnect({ network }) {
  const networkToText = {
    [FACEBOOK]: i18n._('Find friends from Facebook'),
    [GPLUS]: i18n._('Find friends from Google+'),
    [YAHOO]: i18n._('Find friends from Yahoo'),
  };

  return (
    <div className="socialConnect" role="listitem">
      <Touchable onTouch={() => showSocialConnectPanel(network)} fullWidth={false}>
        <div className="socialConnectItem">
          <div className="left">
            <div className={cx('icon', `socialConnect-${network}`)}>
              <em />
            </div>
          </div>
          <div className="right">
            <h4 className="title">{networkToText[network]}</h4>
          </div>
        </div>
      </Touchable>
    </div>
  );
}

SocialConnect.propTypes = {
  network: PropTypes.oneOf([FACEBOOK, GPLUS, YAHOO]).isRequired,
};
